import img1 from "../Assets/Gallery/1.jpg";
import img2 from "../Assets/Gallery/2.jpg";
import img3 from "../Assets/Gallery/3.jpg";
import img4 from "../Assets/Gallery/4.jpg";
import video1 from "../Assets/Gallery/video1.mp4";
import video2 from "../Assets/Gallery/video2.mp4";
import {Link} from "react-router-dom";

const galleryItems = [
  { type: "image", src: img1 },
  { type: "video", src: video1 },
  { type: "image", src: img2 },
  { type: "image", src: img3 },
  { type: "video", src: video2 },
  { type: "image", src: img4 },
];

const Gallery = () => {
  return (
    <div className="bg-black text-white py-16 px-6">
      <div className="container mx-auto">
        
        {/* Title */}
        <h2 className="text-4xl font-bold text-center mb-8">Gallery</h2>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {galleryItems.map((item, index) => (
            <div key={index} className="overflow-hidden rounded-lg">
              <Link to="/portfolio">
              {item.type === "image" ? (
                <img
                  src={item.src}
                  alt={`Gallery ${index + 1}`}
                  className="w-[350px] h-[250px] object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                />
              ) : (
                <video
                  src={item.src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-[350px] h-[250px] object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                />
              )}
              </Link>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Gallery;
